import { Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import { integrationsMCPIDsKeys } from "../../../../api/queryKeys";
import LoadingIcon from "../../../../components/LoadingIcon";
import { CustomerFeatureFlagsContext } from "../../../../contexts/CustomerFeatureFlagsContext";
import AINotIncludedModal from "./AINotIncludedModal";
import IntegrationMCPConnection from "./IntegrationMCPConnection";
import MissingMDMBanner from "./MissingMDMBanner";
import { useMCP } from "./useMCP";

export default function MCPPage() {
  const colors = useColors();
  const { getIntegrationsMCPIDs } = useAPI();
  const {
    availableMCPIntegrations,
    mcpIntegrations,
    anyMCPIntegrationRegistered,
  } = useMCP();

  const [showAINotIncludedModal, setShowAINotIncludedModal] = useState(false);
  const { aiPostureMcpEnabled } = useContext(CustomerFeatureFlagsContext);

  useEffect(() => {
    if (!aiPostureMcpEnabled) {
      setTimeout(() => {
        setShowAINotIncludedModal(true);
      }, 1000);
    }
  }, [aiPostureMcpEnabled]);

  const integrationsMCPIDsQuery = useQuery({
    queryKey: integrationsMCPIDsKeys.all,
    queryFn: () =>
      getIntegrationsMCPIDs(
        availableMCPIntegrations.map((tool) => tool.codeName)
      ),
    select: (data) => data.data,
  });

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        gap={3}
        maxWidth="800px"
        paddingLeft="8px"
      >
        {integrationsMCPIDsQuery.isLoading ? (
          <LoadingIcon />
        ) : integrationsMCPIDsQuery.isError ? (
          <Typography
            variant="caption"
            color={colors.text_secondary}
            sx={{ padding: "0 16px" }}
          >
            Error loading this page. Please try again later.
          </Typography>
        ) : integrationsMCPIDsQuery.isSuccess ? (
          <>
            {!anyMCPIntegrationRegistered ? <MissingMDMBanner /> : null}
            <Box padding="0 8px" display="flex" flexDirection="column" gap={3}>
              <Box display="flex" flexDirection="column" gap={1}>
                <Typography variant="subtitle1" color={colors.text_primary}>
                  MCP Monitoring Guides
                </Typography>
                <Typography variant="body2" color={colors.text_secondary}>
                  Follow the guide for each MDM you use, paste the device MCP ID
                  from the script output, and save.
                  <br />
                  Results appear after the nightly scan.
                </Typography>
              </Box>
              <Box display="flex" flexDirection="column" gap={4}>
                {mcpIntegrations.map((tool) => (
                  <IntegrationMCPConnection
                    key={tool.codeName}
                    integrationData={tool}
                    initialValue={
                      integrationsMCPIDsQuery.data[tool.codeName] ?? ""
                    }
                  />
                ))}
              </Box>
            </Box>
            <AINotIncludedModal
              open={showAINotIncludedModal}
              setOpen={setShowAINotIncludedModal}
            />
          </>
        ) : null}
      </Box>
    </>
  );
}
